var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFasterDeals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m319.1 0-53 214.9 127.1 33.1s-66.8 88-200.4 264l53-214.7-127-33.3s66.8-88 200.3-264z",
    fill: "#ffb703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.8 264s66.8-88 200.4-264l-111.4 236.8z",
    fill: "#fed402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.2 248s-66.8 88-200.4 264l111.4-236.8z",
    fill: "#fed402"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.1 0-111.3 236.8 96.4 38.4 89-27.2-127.1-33.1z",
    fill: "#ffc803"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFasterDeals);
export default __webpack_public_path__ + "static/media/faster-deals.6b66b43bdc4110af6be7efd4af76af42.svg";
export { ForwardRef as ReactComponent };